// @flow
import {BaseApi} from 'modules/api/base';

class ConsoleApi extends BaseApi {
    constructor(slaveHost, password) {
        super();
        this.url = slaveHost || '';
        this.clusterAuth = password
            ? {
                  'X-CLUSTER-AUTH': password,
              }
            : {};
    }

    getConsoleInfo() {
        return this.get(this.url + '/api/v1/console-process/info', {
            headers: {
                ...this.clusterAuth,
            },
        });
    }

    getConsoleList() {
        return this.get(this.url + '/api/v1/console', {
            headers: {
                ...this.clusterAuth,
            },
        });
    }

    confirmStep() {
        return this.put(this.url + '/api/v1/console-process/confirm', {
            headers: {
                ...this.clusterAuth,
            },
        });
    }

    unconfirmStep() {
        return this.put(this.url + '/api/v1/console-process/unconfirm', {
            headers: {
                ...this.clusterAuth,
            },
        });
    }

    editConsole(data: Object) {
        return this.put(this.url + '/api/v1/console-process/init', {
            body: data,
            headers: {
                ...this.clusterAuth,
            },
        });
    }

    changeLanguage(body: Object) {
        return this.put(this.url + '/api/v1/console-process/change-language', {
            body,
            headers: {
                ...this.clusterAuth,
            },
        });
    }

    getBrandingInfo(body: Object) {
        return this.get('/api/v1/console-process/branding-info', {
            body,
        });
    }
}

export {ConsoleApi};
